import { useEffect, useState } from 'react';
import { Drawer, Portal, CloseButton, Box, Button, Tabs } from '@chakra-ui/react';
import PublicContent from '@/components/content-list/public-content';
import useDialogCleanup from '@/lib/hooks/use-dialog-cleanup';
import { ContentType, ExtendedWorkspace } from '@/lib/types';

interface Workspace extends ExtendedWorkspace {
  types: ContentType[];
}

interface Type {
  id: number;
  name: string;
  reference_id: string;
}

interface Props {
  isOpen: boolean;
  onClose(): void;
  workspace: Workspace;
  types: Type[];
}

export default function BrowseContent({ isOpen, onClose, workspace, types }: Props) {
  const [tabIndex, setTabIndex] = useState<string | null>(null);
  useDialogCleanup(isOpen);

  useEffect(() => {
    if (isOpen) {
      setTabIndex(types.length > 0 ? types[0].reference_id : null);
    }
  }, [isOpen, types]);

  return (
    <Drawer.Root
      id={'browse-content-drawer'}
      size='xl'
      placement='end'
      lazyMount
      unmountOnExit
      open={isOpen}
      onOpenChange={(details) => {
        if (!details.open) onClose();
      }}
    >
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content>
            <Drawer.CloseTrigger asChild>
              <CloseButton size='sm' />
            </Drawer.CloseTrigger>
            {workspace && (
              <Drawer.Header>
                <Drawer.Title>{workspace.name}</Drawer.Title>
              </Drawer.Header>
            )}
            <Drawer.Body>
              {types.length === 0 && <Box>No content available</Box>}
              {tabIndex && (
                <>
                  <Box mb={3} w={'full'}>
                    <Tabs.Root
                      value={tabIndex}
                      orientation='horizontal'
                      size='lg'
                      onValueChange={(e) => setTabIndex(e.value)}
                    >
                      <Tabs.List>
                        {types.map((type) => (
                          <Tabs.Trigger key={type.id} value={type.reference_id} asChild>
                            <Button colorPalette='brand' variant='ghost'>
                              {type.name}
                            </Button>
                          </Tabs.Trigger>
                        ))}
                      </Tabs.List>
                    </Tabs.Root>
                  </Box>

                  <PublicContent referenceId={tabIndex} />
                </>
              )}
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
}
